import { render, staticRenderFns } from "./BuilderPaymentConfig.vue?vue&type=template&id=27d555ba&scoped=true"
import script from "./BuilderPaymentConfig.vue?vue&type=script&lang=js"
export * from "./BuilderPaymentConfig.vue?vue&type=script&lang=js"
import style0 from "./BuilderPaymentConfig.vue?vue&type=style&index=0&id=27d555ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d555ba",
  null
  
)

export default component.exports